import { DialogComponent } from '@theme/dialog';

/**
 * Custom element to manage the mobile search drawer.
 *
 * Extends the base DialogComponent so we inherit scroll locking,
 * focus management, and escape/overlay handling.
 */
class SearchDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
  }

  /**
   * Public method to open the drawer.
   */
  open() {
    this.showDialog();
    this.dispatchEvent(new CustomEvent('search-drawer:open', { bubbles: true }));
  }

  /**
   * Public method to close the drawer.
   */
  close() {
    this.closeDialog();
    this.dispatchEvent(new CustomEvent('search-drawer:close', { bubbles: true }));
  }
}

if (!customElements.get('search-drawer-component')) {
  customElements.define('search-drawer-component', SearchDrawerComponent);
}

